import { SectionReveal, ChapterHeading } from "./Shared";
import { useLang } from "../../i18n";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/gi, "-");

const IngredientList = ({ title, items, prefix }) => (
  <div>
    <h3 className="font-display text-xl font-bold text-[#221A3D] sm:text-2xl">{title}</h3>
    <ul className="mt-6">
      {items.map((m, i) => (
        <li
          key={m}
          data-testid={`ingredient-tag-${slug(m)}`}
          className="flex items-baseline justify-between gap-6 border-b border-[#9B7AE8]/12 py-4"
        >
          <span className="text-base text-[#221A3D]">{m}</span>
          <span className="font-code text-xs text-[#8E85AC]">{prefix}{String(i + 1).padStart(2, "0")}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default function Recipes() {
  const { t } = useLang();
  return (
    <section id="receteler" className="relative overflow-hidden border-y border-[#9B7AE8]/15 bg-white py-28" data-testid="recipes-section">
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <ChapterHeading
          index="02"
          label={t.recipes.label}
          title={t.recipes.title}
          sub={t.recipes.sub}
        />

        <SectionReveal delay={0.1} className="mt-16">
          <div className="grid gap-14 lg:grid-cols-2">
            <IngredientList title={t.recipes.macrosTitle} items={t.recipes.macros} prefix="M." />
            <IngredientList title={t.recipes.functionalTitle} items={t.recipes.functional} prefix="F." />
          </div>
        </SectionReveal>

        <div className="mt-24 space-y-24">
          <SectionReveal>
            <div className="grid items-start gap-8 md:grid-cols-2" data-testid="recipe-highlight-custom">
              <h3 className="font-display text-4xl font-bold leading-[1.05] tracking-tight text-[#C9B0FF] sm:text-5xl">
                {t.recipes.h1}
              </h3>
              <p className="max-w-md text-lg leading-relaxed text-black md:justify-self-end">
                {t.recipes.b1}
              </p>
            </div>
          </SectionReveal>
          <SectionReveal delay={0.1}>
            <div className="grid items-start gap-8 md:grid-cols-2" data-testid="recipe-highlight-builder">
              <p className="max-w-md text-lg leading-relaxed text-black md:order-1 md:text-right">
                {t.recipes.b2}
              </p>
              <h3 className="font-display text-4xl font-bold leading-[1.05] tracking-tight text-[#C9B0FF] sm:text-5xl md:order-2 md:text-right">
                {t.recipes.h2}
              </h3>
            </div>
          </SectionReveal>
        </div>
      </div>
    </section>
  );
}
